import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DiffusionPilotageModel } from 'src/models/pilotage/diffusionPilotageModel';
import { VimeoInfoModel } from 'src/models/pilotage/vimeoInfoModel';

@Injectable({
  providedIn: 'root'
})
export class DiffusionService {
  private baseUrl = environment.api_LMS + 'Diffusion';

  constructor(private http: HttpClient) { }

  obtenirDiffusionsParEntite(entiteId: number, utilisateurId: number): Observable<DiffusionPilotageModel[]> {
    return this.http.get<DiffusionPilotageModel[]>(`${this.baseUrl}/obtenirParEntite`, {
      params: {
        entiteId: entiteId.toString(),
        utilisateurId: utilisateurId.toString()
      }
    });
  }

  obtenirDiffusionParId(id: number): Observable<DiffusionPilotageModel> {
    return this.http.get<DiffusionPilotageModel>(`${this.baseUrl}/${id}`);
  }

  ajouterDiffusion(scormPackageId: number, langue: string, entiteId: number, utilisateurId: number): Observable<DiffusionPilotageModel> {
    return this.http.post<DiffusionPilotageModel>(`${this.baseUrl}/ajouter`, {
      scormPackageId,
      langue,
      entiteId,
      utilisateurId
    });
  }

  ajouterDiffusionMultiple(
    scormPackageIds: number[],
    titre: string,
    langue: string,
    entiteId: number,
    utilisateurId: number
  ): Observable<DiffusionPilotageModel> {
    return this.http.post<DiffusionPilotageModel>(`${this.baseUrl}/ajouterMultiple`, {
      scormPackageIds,
      titre,
      langue,
      entiteId,
      utilisateurId
    });
  }

  modifierDiffusion(diffusionId: number, scormPackageId: number, titre: string | null | undefined, langue: string, utilisateurId: number): Observable<DiffusionPilotageModel> {
    return this.http.post<DiffusionPilotageModel>(`${this.baseUrl}/modifier`, {
      diffusionId,
      scormPackageId,
      titre,
      langue,
      utilisateurId
    });
  }

  modifierDiffusionMultiple(diffusionId: number, scormPackageIds: number[], titre: string, langue: string, utilisateurId: number): Observable<DiffusionPilotageModel> {
    return this.http.post<DiffusionPilotageModel>(`${this.baseUrl}/modifierMultiple`, {
      diffusionId,
      scormPackageIds,
      titre,
      langue,
      utilisateurId
    });
  }

  supprimerDiffusion(id: number, utilisateurId: number): Observable<DiffusionPilotageModel> {
    return this.http.delete<DiffusionPilotageModel>(`${this.baseUrl}/supprimer/${id}`, {
      params: {
        utilisateurId: utilisateurId.toString()
      }
    });
  }

  obtenirVimeoIdParToken(token: string): Observable<VimeoInfoModel> {
    return this.http.get<VimeoInfoModel>(`${this.baseUrl}/obtenirVimeoIdParToken`, {
      params: {
        token: token
      }
    });
  }
}